import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { EventStreamMarshaller as UniversalEventStreamMarshaller } from "@smithy/eventstream-serde-universal";
import { iterableToReadableStream, readableStreamtoIterable } from "./utils";
export var EventStreamMarshaller = /*#__PURE__*/function () {
  function EventStreamMarshaller(_ref) {
    var utf8Encoder = _ref.utf8Encoder,
      utf8Decoder = _ref.utf8Decoder;
    _classCallCheck(this, EventStreamMarshaller);
    this.universalMarshaller = new UniversalEventStreamMarshaller({
      utf8Decoder: utf8Decoder,
      utf8Encoder: utf8Encoder
    });
  }
  _createClass(EventStreamMarshaller, [{
    key: "deserialize",
    value: function deserialize(body, deserializer) {
      var bodyIterable = isReadableStream(body) ? readableStreamtoIterable(body) : body;
      return this.universalMarshaller.deserialize(bodyIterable, deserializer);
    }
  }, {
    key: "serialize",
    value: function serialize(input, serializer) {
      var serialziedIterable = this.universalMarshaller.serialize(input, serializer);
      return typeof ReadableStream === "function" ? iterableToReadableStream(serialziedIterable) : serialziedIterable;
    }
  }]);
  return EventStreamMarshaller;
}();
var isReadableStream = function isReadableStream(body) {
  return typeof ReadableStream === "function" && body instanceof ReadableStream;
};